import { GraphType } from "../model/generic-graph";

export const topTenCustomersMock = {
    title: 'Top 10 Customers',
    type: GraphType.TOP_CUSTOMERS,
    navigation: {
        type: 'GraphNavigation',
        nav: {
            qtd: [
                {
                    title: 'C',
                    graph: {
                        data: [
                            {
                                title: 'INDIAN POTASH LIMITED',
                                value: {
                                    value: 233,
                                    positive: 0
                                },
                                kmt: {
                                    value: 548,
                                    positive: 0
                                },
                                price: {
                                    value: 425,
                                    positive: 0
                                }
                            },
                            {
                                title: 'Coop internal consumption',
                                value: {
                                    value: 200,
                                    positive: 0
                                },
                                kmt: {
                                    value: 548,
                                    positive: 0
                                },
                                price: {
                                    value: 425,
                                    positive: 0
                                }
                            },
                            {
                                title: 'AMAGGI IMPORTACAO E EXPORTACAO',
                                value: {
                                    value: 180,
                                    positive: 0
                                },
                                kmt: {
                                    value: 548,
                                    positive: 0
                                },
                                price: {
                                    value: 425,
                                    positive: 0
                                }
                            },
                            {
                                title: 'CHS',
                                value: {
                                    value: 160,
                                    positive: 0
                                },
                                kmt: {
                                    value: 548,
                                    positive: 0
                                },
                                price: {
                                    value: 425,
                                    positive: 0
                                }
                            },
                            {
                                title: 'GROWMARK, INC',
                                value: {
                                    value: 156,
                                    positive: 0
                                },
                                kmt: {
                                    value: 548,
                                    positive: 0
                                },
                                price: {
                                    value: 425,
                                    positive: 0
                                }
                            },
                            {
                                title: 'Guangdong Tianhe Agriculture',
                                value: {
                                    value: 150,
                                    positive: 0
                                },
                                kmt: {
                                    value: 548,
                                    positive: 0
                                },
                                price: {
                                    value: 425,
                                    positive: 0
                                }
                            },
                            {
                                title: 'petrovietnam ca mau fertilizer joint stock company',
                                value: {
                                    value: 100,
                                    positive: 0
                                },
                                kmt: {
                                    value: 548,
                                    positive: 0
                                },
                                price: {
                                    value: 425,
                                    positive: 0
                                }
                            },
                            {
                                title: 'Adubos Sudoeste Ltda',
                                value: {
                                    value: 90,
                                    positive: 0
                                },
                                kmt: {
                                    value: 548,
                                    positive: 0
                                },
                                price: {
                                    value: 425,
                                    positive: 0
                                }
                            },
                            {
                                title: 'MEHERRIN - FERTILIZER',
                                value: {
                                    value: 80,
                                    positive: 0
                                },
                                kmt: {
                                    value: 548,
                                    positive: 0
                                },
                                price: {
                                    value: 425,
                                    positive: 0
                                }
                            },
                            {
                                title: 'AGROPECUARIA MAGGI',
                                value: {
                                    value: 75,
                                    positive: 0
                                },
                                kmt: {
                                    value: 548,
                                    positive: 0
                                },
                                price: {
                                    value: 425,
                                    positive: 0
                                }
                            },
                        ]
                    }
                },
            ],
        }
    }
};